import { render, staticRenderFns } from "./SelectTagModify.vue?vue&type=template&id=527a47fe"
import script from "./SelectTagModify.vue?vue&type=script&lang=js"
export * from "./SelectTagModify.vue?vue&type=script&lang=js"
import style0 from "./SelectTagModify.vue?vue&type=style&index=0&id=527a47fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports